import type { NumberLearningConfig } from './types';

export const DEFAULT_NUMBER_LEARNING_CONFIG: NumberLearningConfig = {
    recentWindows: [10, 20, 30, 50, 100, 200],
    blockSize: 100,
    maxConcursosAnalisados: null,
    validationDraws: 100,
    weights: {
        frequenciaHistorica: 20,
        frequenciaRecente: 20,
        regularidade: 15,
        consistencia: 10,
        estabilidade: 10,
        tendencia: 10,
        recencia: 5,
        atividade: 5,
        oscilacao: 3,
        persistencia: 2,
    },
};

export const ATIVIDADE_LABELS: Record<string, string> = {
    muito_baixa: 'Muito baixa',
    baixa: 'Baixa',
    normal: 'Normal',
    alta: 'Alta',
    muito_alta: 'Muito alta',
};

export const TENDENCIA_LABELS: Record<string, string> = {
    crescente: 'Crescente',
    estavel: 'Estável',
    decrescente: 'Decrescente',
};

export const PERCENTIL_BANDS = [
    { limit: 1, label: 'Top 1%' },
    { limit: 5, label: 'Top 5%' },
    { limit: 10, label: 'Top 10%' },
    { limit: 20, label: 'Top 20%' },
    { limit: 30, label: 'Top 30%' },
    { limit: 50, label: 'Top 50%' },
];

export const CONFIDENCE_PERCENTILE_SLICES = [10, 20, 30, 40, 50, 60, 70, 80, 90, 100];
